import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { forYou, notForYou } from '../data/content';
export function AudienceSection() {
  return <section className="w-full bg-cream py-14 sm:py-16 lg:py-20" aria-labelledby="para-quien" data-id="element-14" data-mp="n3kzd69k78e5">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-15" data-mp="s1e5y0ery4ey">
        <h2 id="para-quien" className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl" data-id="element-16" data-mp="wymm5vgd3ydk">
          ¿Es para vos?
        </h2>

        <div className="mt-7 grid grid-cols-1 gap-4 lg:grid-cols-2" data-id="element-17" data-mp="4a8lf7xw2nyb">
          <div className="flex flex-col rounded-2xl border border-verde/25 bg-verde-soft p-6 sm:p-7" data-id="element-18" data-mp="9ad6lb9qs6uv">
            <h3 className="font-display text-lg font-bold uppercase tracking-tight text-verde-dark" data-id="element-19" data-mp="e0jtn6olvjb0">
              Es para vos si…
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-20" data-mp="3cqaibonjxmvb">
              {forYou.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-ink sm:text-base" data-id="element-21" data-mp="3hovad0snh08o">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-verde" aria-hidden="true" data-id="element-22" data-mp="14aauxbf59ppw" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-2xl border border-ink/10 bg-white p-6 sm:p-7" data-id="element-23" data-mp="ujoi1oytbdaw">
            <h3 className="font-display text-lg font-bold uppercase tracking-tight text-ink-muted" data-id="element-24" data-mp="qimhn4t5sv7c">
              No es para vos si…
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-25" data-mp="gl83xcymekiq">
              {notForYou.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-ink-soft sm:text-base" data-id="element-26" data-mp="gnkugeig237e">
                  <MinusIcon className="mt-0.5 h-5 w-5 shrink-0 text-ink-muted" aria-hidden="true" data-id="element-27" data-mp="7m4jo5npvz2n" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-auto pt-5 text-sm leading-relaxed text-ink-muted" data-id="element-28" data-mp="21zmac1jf5c1w">
              Si estás en esta columna, todo bien: este material probablemente no te sirva y preferimos
              decírtelo antes.
            </p>
          </div>
        </div>
      </div>
    </section>;
}